import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../constants/actionTypes";
import { logUI } from "../../../api/andyliticsApi";
import * as Tools from "../../../helpers/Tools";
import { queryParams } from "../../../helpers/formatting";
import { Typography, Grid, Radio } from "../../ecosystem/";
import { CareGapsButtons, CareGapsHeading, CareGapsQuestionHeading } from './components';
import CareGapsConfirmationModal from "./CareGapsConfirmationModal";
import * as queryString from 'query-string';

class MammographyScreening extends React.Component {
    constructor(props) {
        super(props);
        let params = location.search ? queryString.parse(location.search) : {};      
        let stringifiedParams = JSON.stringify(params).toLowerCase();        
        params = JSON.parse(stringifiedParams);        
        const { saveCareGapsSessionId, careGapsSessionId } = this.props;
        this.state = {
            selectedOption: null,
            showModal: false,
            careGapsSessionId: params.sessionid || careGapsSessionId
        }
        saveCareGapsSessionId(this.state.careGapsSessionId)
    }

    componentDidMount() {
        const { careGapsSessionId } = this.state;
        logUI("MBHWeb.UI.MammographyScreening.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId }); 
        this.populatePreCheckedSelectOption();
    }

    populatePreCheckedSelectOption = () => {
        const { selectedMammographyOption } = this.props;
        this.setState({ selectedOption: selectedMammographyOption, showModal: Boolean(selectedMammographyOption) })
    }

    onChangeValue = (event) => {       
        this.props.clearFlowData(this.state.careGapsSessionId);
        this.setState({ selectedOption: event.target.value, showModal: true }, () => {
            const { careGapsSessionId, selectedOption } = this.state;
            logUI(`MBHWeb.UI.MammographyScreening.SelectedOption.Clicked`, new Date(), Tools.getURLPath(), { selectedOption, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
            }
            );        
    }

    handleClickNext = (event) => {
        this.setState({ ...this.state, showModal: "No, let’s set one up" !== this.state.selectedOption}, () => {
            const { updateMammographyFlowSelectedOption, history, careGapsSessionId } = this.props;
            const { selectedOption } = this.state;
            updateMammographyFlowSelectedOption(selectedOption);
            logUI(`MBHWeb.UI.MammographyScreening.Next.Clicked`, new Date(), Tools.getURLPath(), { selectedOption, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
            if (selectedOption === "No, let’s set one up") {
                const findcareSearchParms = "?" + queryParams({
                    keyword: "mammography",
                    tab: 2,
                    //bypassProxyAndInfo: true
                    ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId })
                });
                history.push({ pathname: '/findcare', search: findcareSearchParms })
            } else {
                history.push('/schedulemymammogram/updatehistory')
            }
        })
    }
    
    render() {
        const { selectedOption, showModal } = this.state
        const subHeading = "Your medical record shows that you are due for a mammogram. Let’s schedule one or update your health history so we’re up to date.";
        const options = ['Yes', 'No, let’s set one up', 'I don’t need a mammogram']

        return (
            <Grid fluid className="body-content body-content--no-top-offset screening-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <CareGapsHeading
                            heading="Breast Cancer Screening"
                            description={subHeading}
                        />
                        <CareGapsQuestionHeading question="Have you had a mammogram in the past 2 years?" /> 

                        <div className="row">
                            <div className="col-lg-8 col-xl-6">
                                <div className="screening-radio-container">
                                    {options && options.map((option, index) => {
                                        return (
                                            <Radio
                                                label={option}
                                                selected={selectedOption}
                                                handleOnclick={this.onChangeValue}
                                                disabled={false}
                                                key={ index}
                                                index={index}
                                                variant="select"
                                                optionsLength={options.length}
                                            />
                                        )
                                    })}
                                </div>

                            </div>
                        </div>

                        <CareGapsButtons
                            prev={{
                                hide: true
                            }}
                            next={{
                                disabled: selectedOption == null,
                                onClick: () => this.handleClickNext()
                            }}
                        />

                    </div>
                </div>
                {showModal && <CareGapsConfirmationModal />}
            </Grid>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        selectedMammographyOption: state.careGap.selectedMammographyOption,
        history: state.session.history,
        careGapsSessionId: state.careGap.careGapsSessionId
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateMammographyFlowSelectedOption: (selectedOption) => dispatch({ type: types.UPDATE_MAMMOGRAPHY_FLOW_SELECTED_OPTION, selectedOption }),
        clearFlowData: (careGapsSessionId) => { dispatch({ type: types.CLEAR_MAMMOGRAPHY_DATA_AFTER_ONCHANGE, careGapsSessionId }) },
        saveCareGapsSessionId: (careGapsSessionId) => { dispatch({ type: types.SAVE_CAREGAPS_SESSION_ID, careGapsSessionId }) }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MammographyScreening);
